import { Directive, ElementRef, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appSwipe]'
})
export class SwipeDirective {
  private touchStartX: number = 0;
  private touchStartY: number = 0;
  private touchEndX: number = 0;
  private touchEndY: number = 0;
  private minSwipeDistance: number = 50; // Schwelle in px

  @Output() swipeleft = new EventEmitter<void>();
  @Output() swiperight = new EventEmitter<void>();
  @Output() swipeup = new EventEmitter<void>();
  @Output() swipedown = new EventEmitter<void>();

  constructor(private el: ElementRef) {}

  @HostListener('touchstart', ['$event'])
  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
    this.touchStartY = event.changedTouches[0].screenY;
  }

  @HostListener('touchend', ['$event'])
  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    this.touchEndY = event.changedTouches[0].screenY;
    this.handleSwipe();
  }

  private handleSwipe() {
    const deltaX = this.touchEndX - this.touchStartX;
    const deltaY = this.touchEndY - this.touchStartY;

    // Horizontaler Swipe
    if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > this.minSwipeDistance) {
      if (deltaX < 0) {
        this.swipeleft.emit();
      } else {
        this.swiperight.emit();
      }
    }
    // Vertikaler Swipe
    else if (Math.abs(deltaY) > this.minSwipeDistance) {
      if (deltaY < 0) {
        this.swipeup.emit();
      } else {
        this.swipedown.emit();
      }
    }
  }
}